/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";
if (typeof Promise === "undefined") {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  require("promise/lib/rejection-tracking").enable();
  window.Promise = require("promise/lib/es6-extensions.js");
}
// fetch() polyfill for making API calls.
require("whatwg-fetch");
// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = require("object-assign");
// Support for...of (a commonly used syntax feature that requires Symbols)
require("core-js/es/symbol");
// Support iterable spread (...Set, ...Map)
require("core-js/stable/array/from");
// Support Map
require("core-js/es/map");
// Require functions for IE
require("core-js/stable/array/find");
require("core-js/stable/string/starts-with");
require("core-js/stable/string/ends-with");
require("core-js/stable/symbol/iterator");
require("core-js/stable/object/values");
require("core-js/stable/object/entries");
require("core-js/stable/array/includes");

require("core-js");
